'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$scope', '$rootScope', '$utils',
    function($scope, $rootScope, $utils) {
        $rootScope.title = 'Заявки на рассмотрении';

        $scope.openControlSidebar = $utils.openControlSidebar;
        $scope.hideFilters = hideFilters;

        $scope.oldFilters = [];
        $scope.filters = [];

        function hideFilters() {
            if ($scope.filters.length > 0) {
                $scope.oldFilters = $scope.filters;
                $scope.filters = [];
            } else {
                $scope.isSetFilters = false;
                $scope.filters = $scope.oldFilters;
            }
        }

        $scope.updateScopeFilters = function(newFilters) {
            $scope.filters = newFilters;
        };

        $scope.$watch('filters', function() {
            $scope.isSetFilters = $scope.filters.length > 0;
        });
    }];
